import { COLORS } from "./Constants"
import { generalStyles as gs } from "../components/styles/styles"

// Marqueur des fiches liées (Jordan 30.10, lot 6) : le bouton qui ouvre une
// fiche liée garde sa forme ; seules l'icône et la bordure prennent la
// couleur de la fiche liée — vert si soldée, rouge s'il reste à payer (même
// calcul que son badge « Soldé / Reste à payer », servi par le serveur :
// `soldes_liees`, svp/fiches_liees). Sans information : gris foncé (avant).
// → { style (à fusionner dans le bouton), titre (suffixe de l'infobulle) }.
export const marqueurFicheLiee = (soldes, type, id) => {
	const e = soldes && soldes[type] ? soldes[type][id] : null
	if (!e) return { style: gs.iconBtn(COLORS.text), titre: "" }
	const couleur = e.soldee ? COLORS.success : COLORS.danger
	return {
		style: { ...gs.iconBtn(couleur), border: `1px solid ${couleur}` },
		titre: e.soldee
			? " — soldée"
			: ` — reste à payer : ${(parseFloat(e.reste) || 0).toFixed(2)} CHF`,
	}
}
